import React, {ReactNode, useMemo} from 'react';

import {useGate, useStore} from 'effector-react';
import {TFunction} from 'i18next';
import {useTranslation} from 'react-i18next';

import {fetchGridConfig, saveGridConfig} from 'api/gridsConfig';
import {mapTableColumns, Table} from 'components/ui-kit/Table2.0';
import {
    BillingGate,
    pageNumberChanged,
    billingState$,
    pageNumber$,
    tableState$,
    filtersChanged,
    filtersReset,
    sortingsChanged,
} from 'models/profile/billing';
import {downloadPending$} from 'models/profile/billingIvoice';
import {BillingRawRow} from 'types/billing';

interface Props {
    configFunc: Array<any>;
    dataMapper: (
        data: BillingRawRow[] | undefined,
        t: TFunction,
        downloadPending: boolean,
    ) => Partial<BillingRawRow>[];
    headerControls?: ReactNode;
    exportConfig?: {
        exportPending: boolean;
        callback: Function;
    };
}

export const BillingGridTable = ({configFunc, dataMapper, headerControls, exportConfig}: Props) => {
    const {t} = useTranslation();
    const state = useStore(billingState$);
    const pageNumber = useStore(pageNumber$);
    const {filters, sortings} = useStore(tableState$);
    const downloadPending = useStore(downloadPending$);
    useGate(BillingGate);
    console.log('state', state);
    const columns = useMemo(
        () =>
            mapTableColumns(
                configFunc,
                filters,
                filtersChanged,
                filtersReset,
                sortings,
                sortingsChanged,
            ),
        [t, sortings, filters],
    );
    const mappedData = React.useMemo(() => dataMapper(state.data?.data, t, downloadPending), [
        dataMapper,
        state,
        t,
        downloadPending,
    ]);

    return (
        <Table
            columns={columns}
            data={mappedData}
            totalRowsCount={state.data?.totalElements}
            pageCount={state.data?.totalPages}
            pageIndex={pageNumber}
            onPageChange={pageNumberChanged}
            isLoading={state.loading}
            headerControls={headerControls}
            userConfig={{
                gridName: 'billingGrid',
                saveConfig: saveGridConfig,
                getConfig: fetchGridConfig,
            }}
            exportConfig={exportConfig}
        />
    );
};
